import "./styles/typography.css";
import "./styles/base.css";
import { initMotion } from "./motion";

function boot(): void {
	initMotion();
}

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
	boot();
}
